export const galleryImages = [
  {
    id: 1,
    src: "https://i.ibb.co/nN66m1hJ/Guvera-barber-shop-haircut-1.jpg",
    alt: "Professional haircut style 1",
    category: "Classic Cuts"
  },
  {
    id: 2,
    src: "https://i.ibb.co/Z6Rd0fCW/Guvera-barber-shop-haircut-2.jpg",
    alt: "Professional haircut style 2",
    category: "Modern Styles"
  },
  {
    id: 3,
    src: "https://i.ibb.co/kV9cWtYL/Guvera-barber-shop-haircut-3.jpg",
    alt: "Professional haircut style 3",
    category: "Beard Styling"
  },
  {
    id: 4,
    src: "https://i.ibb.co/QF2DHjzj/Guvera-barber-shop-haircut-4.jpg",
    alt: "Professional haircut style 4",
    category: "Classic Cuts"
  },
  {
    id: 5,
    src: "https://i.ibb.co/cSqsHS3x/Guvera-barber-shop-haircut-5.jpg",
    alt: "Professional haircut style 5",
    category: "Modern Styles"
  },
  {
    id: 6,
    src: "https://i.ibb.co/bMfWbzSg/Guvera-barber-shop-haircut-6.jpg",
    alt: "Professional haircut style 6",
    category: "Beard Styling"
  },
  {
    id: 7,
    src: "https://i.ibb.co/qMtz8Tkt/Guvera-barber-shop-haircut-7.jpg",
    alt: "Professional haircut style 7",
    category: "Classic Cuts"
  },
  {
    id: 8,
    src: "https://i.ibb.co/1Jp1w3Sj/Guvera-barber-shop-haircut-8.jpg",
    alt: "Professional haircut style 8",
    category: "Modern Styles"
  }
];